import { render, staticRenderFns } from "./item-select.vue?vue&type=template&id=56679ca7&scoped=true&"
import script from "./item-select.vue?vue&type=script&lang=js&"
export * from "./item-select.vue?vue&type=script&lang=js&"
import style0 from "./item-select.vue?vue&type=style&index=0&id=56679ca7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56679ca7",
  null
  
)

export default component.exports